import { useCallback } from "react";
import { useSaveDealerMutation } from "../mutations/useSaveDealer.mutation";
import { DealerInterface } from "../../../interfaces/dealerInterface";

export const useSaveDealer = () => {
  const saveMutation = useSaveDealerMutation();

  const handleSave = useCallback(
    (values: DealerInterface) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
